import { render, staticRenderFns } from "./ButtonSecondaryAccordion.vue?vue&type=template&id=b00e9058&scoped=true"
import script from "./ButtonSecondaryAccordion.vue?vue&type=script&lang=js"
export * from "./ButtonSecondaryAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00e9058",
  null
  
)

export default component.exports